<app-restaurant-header></app-restaurant-header>
<app-page-header [breadcrumbs]="[
    {label: 'Home',       url: '/'},
    {label: 'Chi siamo', url: ''}
]"></app-page-header>

<div class="block">
    <div class="container">
        <div *ngIf="logo" class="text-center mb-2"><img [src]="logo"
                style="max-width: 300px; max-height:100px"></div>
        <h1 class="text-center mb-3" style="color: var(--light-opposite-color)">{{store.name}}</h1>
        <p class="text-center" style="color: var(--light-opposite-color)" *ngIf="shopInfo?.message_to_user">
            {{shopInfo.message_to_user}}
        </p>

       
        <div class="card mb-0 contact-us">
            <div class="card-body">
                <div class="contact-us__container">
                    <div class="row">
                        <div class="col-12 pb-4 pb-lg-0 text-center">

                            <h4 class="contact-us__header card-title mb-1">{{ 'IL' | transloco }}</h4>
                            <div class="contact-us__address pb-2">
                                <table class="w-100">
                                    <tr *ngIf="legalInfo">
                                        <td width="50%" class="legal-row-title">{{'RS' | transloco}}:</td>
                                        <td width="50%" class="legal-row-value">{{legalInfo.legal_ragione_sociale}}</td>
                                    </tr>

                                    <tr *ngIf="legalInfo">
                                        <td width="50%" class="legal-row-title">{{'SL' | transloco}}:</td>
                                        <td width="50%" class="legal-row-value">{{legalInfo.legal_indirizzo}} - {{legalInfo.legal_cap}} {{legalInfo.legal_citta}} ({{legalInfo.legal_provincia}})</td>
                                    </tr>

                                    <tr>
                                        <td width="50%" class="legal-row-title">{{'CF' | transloco}}:</td>
                                        <td width="50%" class="legal-row-value">{{shopInfo?.codice_fiscale}}</td>
                                    </tr>

                                    <tr>
                                        <td width="50%" class="legal-row-title">{{'PIVA' | transloco}}:</td>
                                        <td width="50%" class="legal-row-value">{{shopInfo?.partitaIva}}</td>
                                    </tr>

                                    <ng-container *ngIf="legalInfo">
                                        <tr>
                                            <td width="50%" class="legal-row-title">{{'CS' | transloco}}::</td>
                                            <td width="50%" class="legal-row-value">{{legalInfo.legal_capitale_sociale | currencyFormat}}</td>
                                        </tr>

                                        <tr>
                                            <td width="50%" class="legal-row-title">REA:</td>
                                            <td width="50%" class="legal-row-value">{{legalInfo.legal_rea}}</td>
                                        </tr>

                                        <tr>
                                            <td width="50%" class="legal-row-title">PEC:</td>
                                            <td width="50%" class="legal-row-value">{{legalInfo.legal_pec}}</td>
                                        </tr>

                                        <tr *ngIf="legalInfo.legal_altro">
                                            <td width="50%" class="legal-row-title">{{'Altro'| transloco}}:</td>
                                            <td width="50%" class="legal-row-value">{{legalInfo.legal_altro}}</td>
                                        </tr>
                                        
                                    </ng-container>

                                </table>
                            </div>
                            

                            <h4 class="contact-us__header card-title mb-1 mt-3">{{ 'C'| transloco}}</h4>
                            <div class="contact-us__address pb-2">
                                <table class="w-100">
                                    <tr>
                                        <td width="50%" class="legal-row-title">Email:</td>
                                        <td width="50%" class="legal-row-value">{{shopInfo?.email}}</td>
                                    </tr>
                                    <tr>
                                        <td width="50%" class="legal-row-title">{{ 'TEL'| transloco}}:</td>
                                        <td width="50%" class="legal-row-value">{{shopInfo?.contattoTelefonico}}</td>
                                    </tr>
                                </table>
                            </div>

                            <ng-container *ngIf="orariInfo">
                                <h4 class="contact-us__header card-title mb-3 mt-3">{{'TIME' | transloco}}</h4>
                                <div class="contact-us__address pb-2">
                                    <div class="card-divider"></div>
                                    <div class="card-table">
                                        <div class="table-responsive-md">
                                            <table style="width: 100%; text-align: center;">
                                                <thead>
                                                    <tr>
                                                        <th nowrap *ngFor="let day of daysOrder"
                                                        [ngClass]="{'sunday': day == 0}">
                                                            {{dayName[day]}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td *ngFor="let day of daysOrder">
                                                            <div *ngIf="!orariInfo[day].length">{{'Chiuso' | transloco}}</div>
                                                            <div *ngFor="let orario of orariInfo[day]" style="white-space: nowrap;">
                                                                {{formatTime(orario[0])}}-{{formatTime(orario[1])}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="card-divider"></div>
                                </div>
                            </ng-container>


                            <h4 class="contact-us__header card-title mb-1 mt-3">{{'DoveSiamo'|transloco}}</h4>

                            <div class="contact-us__address">
                                    {{indirizzo}}
                            </div>
                        </div>

                        <div class="col-12 col-lg-6" *ngIf="false">
                            <h4 class="contact-us__header card-title">{{ 'LUM' | transloco}}</h4>

                            <form>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="form-name">Your Name</label>
                                        <input type="text" id="form-name" class="form-control"
                                            placeholder="Your Name">
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="form-email">Email</label>
                                        <input type="email" id="form-email" class="form-control"
                                            placeholder="Email Address">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="form-subject">Subject</label>
                                    <input type="text" id="form-subject" class="form-control"
                                        placeholder="Subject">
                                </div>
                                <div class="form-group">
                                    <label for="form-message">Message</label>
                                    <textarea id="form-message" class="form-control"
                                        rows="4"></textarea>
                                </div>
                                <button type="submit" class="btn btn-primary">Send Message</button>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <div class="contact-us__map" id="store_map"></div>

        </div>
    </div>
     <app-restaurant-footer></app-restaurant-footer>
</div>